import { isDev } from "@/utils/misc";
import axios from "@utils/axios-instance";

export type GoogleAdsAccount = {
  id: string;
  name: string;
};

export const getAccounts = async (): Promise<GoogleAdsAccount[]> => {
  const response = await axios.get("/integrations/googleads/list");
  return response.data;
};

// temp: convert id to string
export const setAccount = async (account: GoogleAdsAccount): Promise<GoogleAdsAccount[]> => {
  const id = account.id.toString();
  const response = await axios.patch("/integrations/googleads/select", { ...account, id });
  return response.data;
};

const disconnectGoogleAdsAccount = async (): Promise<void> => {
  await axios.patch("/integrations/googleads/disconnect");
};

const updateCurrentAdAccount = async (account: GoogleAdsAccount): Promise<void> => {
  await axios.patch("/integrations/googleads/select", account);
};

export const getGoogleAdsConnectionUrl = async (): Promise<string> => {
  const response = await axios.get(`/integrations/googleads/connect?local=${isDev}`);
  const data = response.data as { url: string };
  return data.url;
};

export default {
  getAccounts,
  setAccount,
  disconnectGoogleAdsAccount,
  getGoogleAdsConnectionUrl,
  updateCurrentAdAccount,
};
